import { Truck, Activity, MapPin, Package, Layers } from "lucide-react";

const TILES = [
  ["trucks", "Linked trucks", Truck, "#38BDF8"],
  ["active", "Active now", Activity, "#F97316"],
  ["on_site", "On site", MapPin, "#A855F7"],
  ["loads_today", "Loads today", Package, "#22C55E"],
  ["m3_today", "m³ today", Layers, "#FBBF24"],
];

export function FleetKpis({ summary }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-2" data-testid="ctr-fleet-kpis">
      {TILES.map(([k, label, Icon, color]) => (
        <div key={k} className="bg-[#12151A] border border-[#22262E] px-3 py-2.5 flex items-center gap-3" data-testid={`ctr-kpi-${k}`}>
          <div className="w-8 h-8 flex items-center justify-center shrink-0" style={{ background: `${color}22`, color }}>
            <Icon className="w-4 h-4" />
          </div>
          <div className="min-w-0">
            <div className="text-[9px] tracking-widest uppercase text-[#8B909A] truncate">{label}</div>
            <div className="heading text-xl font-black leading-none text-white mono" data-testid={`ctr-kpi-${k}-value`}>{summary?.[k] ?? "—"}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
